import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, LogIn, Mail } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import CustomerNavbar from '../components/CustomerNavbar';
import Footer from '../components/Footer';

const AccountVerificationSentPage: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const email = (searchParams.get('email') || '').trim();
  const loginType = (searchParams.get('type') || 'customer').trim();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleGoToLogin = () => {
    const loginUrl = loginType ? `/login?type=${encodeURIComponent(loginType)}` : '/login';
    navigate(loginUrl);
  };

  return (
    <div className="min-h-screen bg-white no-animations flex flex-col">
      <CustomerNavbar
        onLogout={handleLogout}
        showDashboardLink={false}
        showLogoutButton={false}
        showAuthButtons={true}
      />

      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 relative z-10">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center">
                <Mail className="h-10 w-10 text-blue-900" strokeWidth={2} />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-gray-900">Verification email sent</h2>
            <p className="mt-2 text-sm text-gray-600">
              Follow the instructions in your email to verify your account.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-blue-900 mb-2">Check your inbox</h4>
                  <p className="text-sm text-blue-700">
                    {email ? (
                      <>
                        We sent a verification email to <span className="font-medium">{email}</span>. Open it and click the
                        verification link to activate your account.
                      </>
                    ) : (
                      <>We sent a verification email to the address you provided. Open it and click the verification link to activate your account.</>
                    )}
                  </p>
                  <div className="text-xs text-blue-600 mt-3">
                    <p>• Check your spam/junk folder if you don&apos;t see the email</p>
                    <p>• Once verified, you can sign in and continue</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <button onClick={handleGoToLogin} className="aacore-btn-primary w-full justify-center inline-flex items-center gap-2">
                <LogIn className="h-4 w-4" />
                Go to Sign In
              </button>

              <Link to="/" className="aacore-btn-outlined w-full justify-center inline-flex items-center gap-2">
                <Home className="h-4 w-4" />
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AccountVerificationSentPage;


